import { WizardStep } from "@shared/components/application/navigation/Wizard/WizardStep.web";
import Addons from "@app-contexts/public/shared/checkout/components/steps/add-ons/Addons.web";
import useCheckoutAddons from "@app-contexts/public/shared/checkout/hooks/useCheckoutAddons";
import { useTranslation } from "@shared/utils/internationalization";

export const ADDONS_STEP_ID = "addons";

export function AddonsStep({
  hideContinueButton,
  modalHeight,
}: {
  hideContinueButton?: boolean;
  modalHeight?: string;
}) {
  // Fetch products to accurately determine if addons step should show
  // This query uses default params; ProductAddons may use different params for display
  const { addonsEligible, hasAddOns, addonsLoaded } = useCheckoutAddons();
  const isReady = addonsEligible ? addonsLoaded : true;
  const shouldRegister = !isReady || (addonsEligible && hasAddOns);
  const { t } = useTranslation("checkout");

  return (
    <WizardStep
      stepId={ADDONS_STEP_ID}
      stepName={t("Add-ons", { ns: "common" })}
      async
      isReady={isReady}
      shouldRegister={shouldRegister}
    >
      <Addons
        hideContinueButton={hideContinueButton}
        modalHeight={modalHeight}
      />
    </WizardStep>
  );
}

AddonsStep.id = ADDONS_STEP_ID;
